export interface SeeMenuWidgetSettings {
  buttonText: string;
  hasRedirectUrl: boolean;
  imageUrl: string;
  redirectUrl: string;
  subTitle: string;
  title: string;
}
